import { RadioGroup } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  RebuildRouteDropdownAvoidTollsRow,
  RebuildRouteDropdownRadioOption,
} from "@ryde/controls";
import {
  DirectionsServiceEnum,
  formatRebuildRouteProviderOptimizationLabel,
  RebuildRouteTypeEnum,
  resolveDirectionsServiceLabel,
} from "@ryde/shared";

interface ICourseRebuildRouteDropdownOptionsSelectorProps {
  supportsAvoidTolls: boolean;
  avoidTolls: boolean;
  isDefaultAvoidTolls: boolean;
  routeOption: RebuildRouteTypeEnum;
  selectedProvider: DirectionsServiceEnum;
  showStationsReorderOptions?: boolean;
  onAvoidTollsChange: (checked: boolean) => void;
  onRouteOptionChange: (option: RebuildRouteTypeEnum) => void;
}

export const CourseRebuildRouteDropdownOptionsSelector: FC<
  ICourseRebuildRouteDropdownOptionsSelectorProps
> = ({
  supportsAvoidTolls,
  avoidTolls,
  isDefaultAvoidTolls,
  routeOption,
  selectedProvider,
  showStationsReorderOptions = true,
  onAvoidTollsChange,
  onRouteOptionChange,
}) => {
  const { t } = useTranslation();
  const providerLabel =
    resolveDirectionsServiceLabel(selectedProvider) ?? selectedProvider;
  const providerOptimizationLabel = formatRebuildRouteProviderOptimizationLabel(
    {
      provider: selectedProvider,
      t,
    },
  );

  return (
    <div className="rebuild-route-dropdown-options">
      {supportsAvoidTolls && (
        <RebuildRouteDropdownAvoidTollsRow
          checked={avoidTolls}
          isDefaultAvoidTolls={isDefaultAvoidTolls}
          onChange={onAvoidTollsChange}
        />
      )}
      <RadioGroup
        value={routeOption}
        onChange={e =>
          onRouteOptionChange(e.target.value as RebuildRouteTypeEnum)
        }
      >
        {showStationsReorderOptions && (
          <>
            <RebuildRouteDropdownRadioOption
              value={RebuildRouteTypeEnum.ProviderOptimization}
              label={providerOptimizationLabel}
              tooltip={t("general.PROVIDER_OPTIMIZATION_TOOLTIP", {
                provider: providerLabel,
              })}
            />
            <RebuildRouteDropdownRadioOption
              value={RebuildRouteTypeEnum.OptimizeStationOrderOsrmFirst}
              label={t("general.OPTIMIZE_STATIONS_ORDER")}
              tooltip={t("general.OPTIMIZE_STATIONS_ORDER_TOOLTIP")}
            />
          </>
        )}
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.KeepOrder}
          label={t("general.REBUILD_KEEP_ORDER")}
          tooltip={t("general.REBUILD_KEEP_ORDER_TOOLTIP")}
        />
        <RebuildRouteDropdownRadioOption
          value={RebuildRouteTypeEnum.EndpointsLocked}
          label={t("general.REBUILD_ENDPOINTS_LOCKED")}
          tooltip={t("general.REBUILD_ENDPOINTS_LOCKED_TOOLTIP")}
        />
      </RadioGroup>
    </div>
  );
};
